<template>
    <div>
        <NavbarStyleTwo />
        <PageTitle
            pageTitle="Individuelle Angebote"
            pageDesc="Maßgeschneiderte Lösungen für Ihr Projekt"
        />
        <IndividuelleAngebote />
        <Faq />
        <OurLovingClients />
        <FreeTrial class="pt-0" />
        <FooterStyleOne />
    </div>
</template>

<script>
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import IndividuelleAngebote from '../Common/IndividuelleAngebote'
import Faq from '../Common/Faq'
import OurLovingClients from '../Common/OurLovingClients'
import FreeTrial from '../Common/FreeTrial'
import FooterStyleOne from '../Layouts/FooterStyleOne'

export default {
    components: {
        NavbarStyleTwo,
        PageTitle,
        IndividuelleAngebote,
        Faq,
        OurLovingClients,
        FreeTrial,
        FooterStyleOne,
    }
};
</script>
